import { cn } from "@/lib/utils";
import {
  candyWrapperTheme,
  JsonEditor,
  JsonEditorProps,
} from "json-edit-react";
import React, { useEffect } from "react";
import { toast } from "react-toastify";

interface Props extends JsonEditorProps {
  setEditorData: (data: any) => void;
  setSearchQuery: (query: string) => void;
  isDeleteConfirmed?: boolean;
  historyConfig?: {
    canUndo: boolean;
    canRedo: boolean;
    undo: () => void;
    redo: () => void;
  };
}

function CustomJsonEditor({
  setEditorData,
  setSearchQuery,
  isDeleteConfirmed = false,
  historyConfig,
  ...props
}: Props) {
  useEffect(() => {
    if (!historyConfig) return;
    const redo = (e: KeyboardEvent) => {
      if (e.key === "y" && e.ctrlKey) {
        if (historyConfig.canRedo) historyConfig.redo();
        else toast.info("No more actions to redo");
      }
    };
    const undo = (e: KeyboardEvent) => {
      if (e.key === "z" && e.ctrlKey) {
        if (historyConfig.canUndo) historyConfig.undo();
        else toast.info("No more actions to undo");
      }
    };
    window.addEventListener("keydown", redo);
    window.addEventListener("keydown", undo);

    return () => {
      window.removeEventListener("keydown", redo);
      window.removeEventListener("keydown", undo);
    };
  }, [historyConfig]);

  return (
    <div className="relative">
      <input
        type="text"
        placeholder="Search JSON fields..."
        value={props.searchText || ""}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="absolute right-5 top-5 z-[20] px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <JsonEditor
        searchFilter={"all"}
        searchDebounceTime={350}
        theme={candyWrapperTheme}
        showIconTooltips
        maxWidth={"100%"}
        collapse={2}
        {...props}
        className={cn(
          "!py-10 !px-20 !rounded-tr-xl !rounded-tl-xl !rounded-br-none !rounded-bl-none",
          props.className
        )}
        setData={setEditorData}
      />
    </div>
  );
}

export default CustomJsonEditor;
